/* eslint-disable */
import React, { useState, useEffect } from "react";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, PUBLISH_REPORT_CONFIG, STORAGE_DESTINATION, TOAST_TYPES } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import BossDialog from "../../components/BossDialog";

// MUI Imports
import {
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    FormControlLabel,
    Box,
} from "@mui/material";

import ToastNotification from "../../components/ToastNotification";
import {
    Cloud as CloudIcon,
    CloudDownload as CloudDownloadIcon,
    FolderShared as FolderSharedIcon,
    Shuffle as ShuffleIcon,
    Dns as DnsIcon,
    Storage as StorageIcon,
    Publish as PublishIcon,
    Mail as MailIcon
} from "@mui/icons-material";

const PublishSettingEditForm = (props) => {
    const lang = useTranslation();

    const publishProvider = PUBLISH_REPORT_CONFIG.filter(data => data.isPubProviderReq == true)

    const [dataItem, setDataItem] = useState({
        SID: props?.item?.SID ?? 0,
        name: props?.item?.name ?? "",
        publish_report_SID: props?.item?.publish_report_SID ? publishProvider.find(data => data.SID == props?.item?.publish_report_SID) : "",
        publishProvider_id: props?.item?.publishProvider_id ? { _id: props?.item?.publishProvider_id } : "",
        Archive: props?.item?.Archive ?? false,
    });
    const [provider, setProvider] = useState([]);

    // Common styles for inputs
    const inputStyle = {
        '& .MuiOutlinedInput-root': {
            minHeight: '48px',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
    };

    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        try {
            let providerRes = await API.getData(ENTITYNAME.PublishProvider, { query: ["Archive", "=", false] });
            console.log(providerRes);
            if (providerRes.success) {
                setProvider(providerRes.data)
                if (props?.item?.publishProvider_id) {
                    setDataItem({
                        ...dataItem,
                        publishProvider_id: providerRes.data.find(p => p._id == props?.item?.publishProvider_id)
                    })
                }
            } else[
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Failed to load publisher provider' })
            ]
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Failed to load publisher provider' })
        }
    }

    const onChange = (e) => {
        const { name, value, checked } = e.target;
        if (name === "Archive") {
            setDataItem(prev => ({ ...prev, Archive: checked }));
        } else {
            setDataItem(prev => ({ ...prev, [name]: value }));
        }
    }

    // Handler for Publisher Select
    const onPublisherChange = (e) => {
        const selectedSID = e.target.value;
        const selectedObj = publishProvider.find(x => x.SID === selectedSID);
        if (selectedObj) {
            setDataItem(prev => ({ ...prev, publish_report_SID: selectedObj }));
        }
    }

    // Handler for Publish Provider Select
    const onProviderChange = (e) => {
        const selectedId = e.target.value;
        const selectedObj = provider.find(x => x._id === selectedId);
        if (selectedObj) {
            setDataItem(prev => ({ ...prev, publishProvider_id: selectedObj }));
        }
    }

    const isValid = () => {
        if (!dataItem.name) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (!dataItem.publish_report_SID) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select Publisher' });
            return false;
        }
        if (!dataItem.publishProvider_id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select provider' });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            name: dataItem.name,
            publish_report_SID: dataItem.publish_report_SID.SID,
            publishProvider_id: dataItem.publishProvider_id._id,
            Archive: dataItem.Archive ?? false,
        }

        console.log(finalData);

        let res = await API.saveData(ENTITYNAME.PublishSetting, finalData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PUBLISH_PROVIDER, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.PublishSetting);
            props.cancelEdit();
            props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    // Icon helper for storage destination
    const getIconForDestination = (storageDestination) => {
        switch (storageDestination) {
            case STORAGE_DESTINATION.Cloudinary: return <CloudIcon sx={{ mr: 1, color: '#3448c5' }} />;
            case STORAGE_DESTINATION.S3: return <CloudIcon sx={{ mr: 1, color: '#FF9900' }} />;
            case STORAGE_DESTINATION.Download: return <CloudDownloadIcon sx={{ mr: 1, color: '#4caf50' }} />;
            case STORAGE_DESTINATION.SharedDirectory: return <FolderSharedIcon sx={{ mr: 1, color: '#9c27b0' }} />;
            case STORAGE_DESTINATION.SFTP:
            case STORAGE_DESTINATION.FTP: return <ShuffleIcon sx={{ mr: 1, color: '#00bcd4' }} />;
            case STORAGE_DESTINATION.Aspera: return <DnsIcon sx={{ mr: 1, color: '#ff5722' }} />;
            case STORAGE_DESTINATION.SMTP: return <MailIcon sx={{ mr: 1, color: '#e91e63' }} />;
            default: return <StorageIcon sx={{ mr: 1, color: '#607d8b' }} />;
        }
    }

    return (
        <BossDialog
            title={props?.item?.name ? props?.item?.name : lang.add_publish_setting_dialog_header}
            onClose={props.cancelEdit}
            width={"600px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

            <Box sx={{ p: 0, mt: 2 }}>
                <Grid container spacing={3}>
                    {/* Name Field */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={lang.name_label}
                            name="name"
                            value={dataItem.name}
                            onChange={onChange}
                            required
                            sx={inputStyle}
                        />
                    </Grid>

                    {/* Publisher Dropdown */}
                    <Grid item xs={6}>
                        <FormControl fullWidth sx={inputStyle}>
                            <InputLabel id="publisher-label">Publisher *</InputLabel>
                            <Select
                                labelId="publisher-label"
                                value={dataItem.publish_report_SID?.SID || ""}
                                label="Publisher *"
                                onChange={onPublisherChange}
                                sx={{ minHeight: '48px' }}
                                renderValue={(selected) => {
                                    const found = publishProvider.find(x => x.SID === selected);
                                    return (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <PublishIcon sx={{ mr: 1, color: '#1976d2' }} />
                                            {found ? found.Description : selected}
                                        </Box>
                                    );
                                }}
                            >
                                {publishProvider.map((pub) => (
                                    <MenuItem key={pub.SID} value={pub.SID}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <PublishIcon sx={{ mr: 1, color: '#1976d2' }} />
                                            {pub.Description}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Publish Provider Dropdown - with storage destination icons */}
                    <Grid item xs={6}>
                        <FormControl fullWidth sx={inputStyle}>
                            <InputLabel id="provider-label">Publish Provider *</InputLabel>
                            <Select
                                labelId="provider-label"
                                value={dataItem.publishProvider_id?._id || ""}
                                label="Publish Provider *"
                                onChange={onProviderChange}
                                sx={{ minHeight: '48px' }}
                                renderValue={(selected) => {
                                    const found = provider.find(x => x._id === selected);
                                    return (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {found && getIconForDestination(found.StorageDestination)}
                                            {found ? found.Name : selected}
                                        </Box>
                                    );
                                }}
                            >
                                {provider.map((prov) => (
                                    <MenuItem key={prov._id} value={prov._id}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {getIconForDestination(prov.StorageDestination)}
                                            {prov.Name}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Archive Checkbox */}
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={dataItem.Archive} onChange={onChange} name="Archive" />}
                            label={lang.archive}
                        />
                    </Grid>
                </Grid>
            </Box>
        </BossDialog>
    )
}
export default PublishSettingEditForm;